import React from "react";
import { isMockModeEnabled } from "./mockMode";

const badgeStyle = {
  position: "fixed",
  top: "1rem",
  right: "1rem",
  zIndex: 9999,
  padding: "0.65rem 0.9rem",
  borderRadius: "999px",
  background: "rgba(9, 19, 42, 0.86)",
  color: "#fff",
  border: "1px solid rgba(255,255,255,0.16)",
  boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
  backdropFilter: "blur(16px)",
  fontSize: "0.82rem",
  lineHeight: 1.2,
  maxWidth: "18rem",
};

const titleStyle = {
  display: "block",
  fontWeight: 700,
  marginBottom: "0.18rem",
};

const textStyle = {
  opacity: 0.82,
  margin: 0,
};

const MockModeBadge = () => {
  if (!isMockModeEnabled()) return null;

  return (
    <aside style={badgeStyle} aria-label="Mock demo badge">
      <span style={titleStyle}>Mock demo activo</span>
      <p style={textStyle}>Reservas, disponibilidad y pagos están simulados.</p>
    </aside>
  );
};

export default MockModeBadge;
